import api from './api';

export const loginAsAdmin = async (username, password) => {
  try {
    const response = await api.post('/auth/login', { username, password });

    const { success, token, refreshToken, user, message } = response.data;

    if (!success) {
      return { success: false, message };
    }
    
    if (hasWebAccess(user.roles)) {
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);
      return { success: true, user, message };
    }

    return { success: false, message: 'Action requires admin privileges'}

  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.errorMessage || 'Login failed'
    };
  }
};

export const logoutUser = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
};

export const getStoredUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

function hasWebAccess(roles) {
  return roles.some(role => 
    role && Array.isArray(role.access) && role.access.includes('web')
  );
}